<!--仓库管理-入库-入库详情  页面ID 1050001-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" type="primary" @click="printOrder">打印入库单</el-button>
        <el-button style="margin-left: 16px" @click="批量上传报告()">批量上传报告</el-button>
        <el-button style="margin-left: 16px" @click="uploadFile">上传入库单</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="listData" class="tableArea" style="width: 100%" border
        @selection-change="(val) => 勾选产品上传报告(val)">
        <el-table-column fixed="left" type="selection" width="55" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="BUYED_PRODUCT_CODE" label="产品编码">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)">
              {{ scope.row.BUYED_PRODUCT_CODE }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="名称">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)">
              {{ scope.row.PRODUCT_NAME }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" width="80">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)">
              {{ scope.row.TYPE_UNIT }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop=REAL_COUNT label="总数">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)" v-if="scope.row.showInput == 0">
              {{ scope.row.REAL_COUNT }}
            </span>
            <el-input v-model="scope.row.REAL_COUNT" @change="countTotalFee(scope.row)" style="width: 100%" v-else>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="REAL_PRICE" label="单价">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)">
              {{ scope.row.REAL_PRICE }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)">
              {{ scope.row.BEFORE_TAX_PRICE }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
        <el-table-column prop="REAL_FEE" label="总价">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)" v-if="scope.row.showInput == 0">
              {{ scope.row.REAL_FEE }}
            </span>
            <el-input v-model="scope.row.REAL_FEE" @change="getCount(scope.row)" style="width: 100%" v-else></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="REAL_FEE_BEFORE_TAX" label="不含税总价">
          <template slot-scope="scope">
            <span :style="setFontColor(scope.row.new_row)" v-if="scope.row.showInput == 0">
              {{ scope.row.REAL_FEE_BEFORE_TAX }}
            </span>
            <el-input v-model="scope.row.REAL_FEE_BEFORE_TAX" style="width: 100%" v-else disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column label="产地" min-width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.PRODUCING_AREA" size="small" clearable style="width: 100%"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="生产日期" min-width="160">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.SEND_DAY" type="date" placeholder="生产日期" style="width: 100%"
              value-format="yyyy-MM-dd" :clearable="false" size="small"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="保质期">
          <template slot-scope="scope">
            <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
          </template>
        </el-table-column>

        <el-table-column label="生产企业" min-width="160">
          <template slot-scope="scope">
            <el-autocomplete v-model="scope.row.SOURCE_COMPANY" size="small" clearable style="width: 100%"
              :fetch-suggestions="fetchSourceCompany" select-when-unmatched popper-class="my-autocomplete-popper"
              :ref="`autocomplete${scope.$index}`" @select="({ value }) => selectSourceCompany(scope.row, value)">
            </el-autocomplete>
          </template>
        </el-table-column>

        <el-table-column label="生产经营许可证编号" min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.CERT_CODE" size="small" clearable style="width: 100%"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="联系人" min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.CONTACT_PERSON" size="small" clearable style="width: 100%"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="联系人电话" min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.CONTACT_PHONE" size="small" clearable style="width: 100%"></el-input>
          </template>
        </el-table-column>

        <el-table-column prop="IN_WAREHOUSE_PRODUCT_CODE" label="入库代码" />
        <el-table-column prop="IN_WAREHOUSE_PRODUCT_NAME" label="入库名称" />
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="text"
              v-if="Number(scope.row.IN_WAREHOUSE_PRODUCT_CODE) === 0 && fun_dic[105000102]"
              @click="editOutProduct(scope.row)">
              编辑入库产品
            </el-button>
            <el-button size="small" type="text" v-if="scope.row.new_row === 0 && fun_dic[105000101]"
              class="el-icon-plus" @click="splitProduct(scope.row, scope.$index)" tabindex="-1">
              拆分
            </el-button>
            <el-button size="small" type="text" style="color:#F56C6C" class="el-icon-minus"
              v-if="scope.row.new_row === 1 && fun_dic[105000101]" @click="deleteSplit(scope.row, scope.$index)"
              tabindex="-1">
              删除
            </el-button>
            <br>
            <el-button type="text" @click="showUploadBatch(scope.row)" size="small">上传批次报告</el-button>
            <br>
            <el-button v-show="scope.row.BATCH_REPORT_ID != 0" size="small" type="text"
              @click="downloadBatch(scope.row.BATCH_REPORT_ID)">
              查询批次报告
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 编辑入库产品模态框 -->
    <el-dialog title="编辑入库产品" :visible.sync="editFormVisible" center>
      <el-form size="small" :inline="true" class="demo-form-inline" style="margin: 0;" :model="seachForm"
        :ref="seachForm" @submit.native.prevent>
        <el-form-item label="产品名称：">
          <el-autocomplete class="inline-input" v-model="seachForm.productName" :fetch-suggestions="querySearch"
            placeholder="请输入产品名称" :trigger-on-focus="false" @select="handleSelect" clearable></el-autocomplete>
        </el-form-item>
      </el-form>
      <el-table :data="dialogData" stripe border>
        <el-table-column property="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column property="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column property="TYPE_UNIT" label="单位"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editFormSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传批次报告" center :visible.sync="uploadBatchFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="uploadBatchForm" :model="uploadBatchForm" label-width="120px">
        <el-form-item label="送检单位：">
          <el-input v-model="uploadBatchForm.SUBMIT_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测机构：">
          <el-input v-model="uploadBatchForm.TEST_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告：">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
            name="qualification" multiple :file-list="fileList" :data="上传批次报告参数">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUploadBatchForm">取 消</el-button>
        <el-button size="small" @click="$uploadBatch()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量上传批次报告" center :visible.sync="批量上传报告模态框" width="500px" :close-on-click-modal="false">
      <el-form ref="批量上传报告表单" :model="批量上传报告表单" label-width="120px">
        <el-form-item label="送检单位：">
          <el-input v-model="批量上传报告表单.SUBMIT_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测机构：">
          <el-input v-model="批量上传报告表单.TEST_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告：">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
            name="qualification" multiple :file-list="fileList" :data="上传批次报告参数">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUploadBatchForm()">取 消</el-button>
        <el-button size="small" @click="确认批量上传报告()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看批次报告" center :visible.sync="查看批次报告模态框" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="查看批次报告模态框表单" :model="查看批次报告模态框表单" label-width="120px">
        <el-form-item label="送检单位" prop="SUBMIT_UNIT">
          <el-input v-model="查看批次报告模态框表单.SUBMIT_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测报告" prop="TEST_UNIT">
          <el-input v-model="查看批次报告模态框表单.TEST_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告">
          <el-button type="text" @click="下载批次报告()">下载报告</el-button>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="查看批次报告模态框 = false">取 消</el-button>
        <el-button size="small" @click="查看批次报告模态框 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col>
        <el-button size="small" @click="submit" style="float:right;margin-top: 20px">全部确认</el-button>
      </el-col>
    </el-row>

    <el-dialog title="上传入库单" center :visible.sync="uploadFileDialog" width="500px" :close-on-click-modal="false">
      <el-form ref="uploadFileForm" :model="uploadFileForm" label-width="120px" label-suffix="：">
        <el-form-item label="入库单" prop="fileList">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload"
            :on-success="$util.handleUploadSuccess.bind(this, 'uploadFileForm', 'fileList')"
            :on-remove="$util.handleUploadRemove.bind(this, 'uploadFileForm', 'fileList')" :name="uploadFileForm.name"
            :limit="1" :file-list="uploadFileForm.fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadFileDialog = false">取 消</el-button>
        <el-button size="small" @click="submitUploadFile">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { MessageBox } from 'element-ui';
import {
  queryInStorageDetailFun, inStorageCofirmFun, chooseEntryFun, print,
} from 'api/warehouseManager';
import { getActionFun } from 'api/login';
import { downloadBatchReport, uploadBatch } from 'api/shopOrderManage';
import store from '../../../store';
import util from '@/assets/common/util';

export default {
  name: 'myNeedDeal',
  data () {
    return {
      orderID: Number(sessionStorage.getItem('orderId')),
      上传批次报告参数: {
        remainName: 1,
      },
      PAGE_ID: '1050001', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 105000101: 0, 105000102: 0 },
      SEND_DAY: '',
      position: 0,
      listData: [],
      ALL_PRODUCTS: [],
      editFormVisible: false,
      dialogData: [],
      seachForm: {},
      inputItemData: {},
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      rawData: [],
      tableList: [],
      realCount: 0,
      count: 0,
      relCountTotal: 0,
      newRealCount: 0,
      uploadBatchFormVisible: false,
      printPageSize: 10,
      勾选产品产品编码列表: [],
      批量上传报告模态框: false,
      查看批次报告模态框表单: {},
      批量上传报告表单: {},
      查看批次报告模态框: false,
      uploadBatchForm: {},
      fileList: [],
      uploadFileDialog: false,
      uploadFileForm: {
        name: 'tmp',
        fileList: [],
      },
      sourceCompanyList: JSON.parse(sessionStorage.getItem('sourceCompanyList')),
      isLeftAfterSubmitting: false,
    };
  },
  watch: {
    uploadFileDialog (newV, _oldV) {
      if (!newV) this.closeUploadFile();
    },
  },
  computed: {
    sotockEnterDetail () {
      return this.$store.state.stock_enter_detail;
    },
  },
  methods: {
    selectSourceCompany (row, value) {
      const sourceCompany = this.sourceCompanyList.find(({ SOURCE_COMPANY }) => SOURCE_COMPANY == value);

      if (sourceCompany) for (const key in sourceCompany) if (key) this.$set(row, key, sourceCompany[key]);
    },
    fetchSourceCompany (value, cb) {
      cb(this.sourceCompanyList.filter(({ SOURCE_COMPANY }) => SOURCE_COMPANY.includes(value)).map(({ SOURCE_COMPANY }) => ({ value: SOURCE_COMPANY })));
    },
    uploadFile () {
      const stockInFileDict = JSON.parse(sessionStorage.getItem('stockInFileDict')) || {};
      if (!this.uploadFileForm.fileList.length && this.orderID in stockInFileDict) this.uploadFileForm.fileList = stockInFileDict[this.orderID] || [];
      this.uploadFileDialog = true;
    },
    closeUploadFile () {
      this.$refs.upload.clearFiles();
      this.$refs.uploadFileForm.resetFields();
      this.uploadFileDialog = false;
    },
    submitUploadFile () {
      this.$refs.uploadFileForm.validate((valid) => {
        if (valid) {
          const stockInFileDict = JSON.parse(sessionStorage.getItem('stockInFileDict')) || {};
          stockInFileDict[this.orderID] = this.uploadFileForm.fileList;
          sessionStorage.setItem('stockInFileDict', JSON.stringify(stockInFileDict));
          this.closeUploadFile();
          this.$message.show({ text: '上传成功', type: 'success' });
        }
      });
    },
    下载批次报告 () {
      window.open(this.$util.getURLLocalHost(this.查看批次报告模态框表单.FILE_PATH), 'file');
    },
    批量上传报告 () {
      if (this.勾选产品产品编码列表.length == 0) {
        this.$message.show({ text: '请勾选需要上传的报告', type: 'warning' });
        return false;
      }
      this.批量上传报告模态框 = true;
    },

    printOrder () {
      const QGP_TIME_TYPE = ['', '年', '季', '个月', '天', '小时'];
      const printDatas = [];
      const printDataAll = Object.assign([], this.listData);
      while (printDataAll.length !== 0) {
        printDatas.push(printDataAll.splice(0, this.printPageSize));
      }

      let html = '';
      printDatas.forEach((printData, index) => {
        html += '<div>';
        html += '<div class="main">';
        html += `<div class="title">${sessionStorage.getItem('company')}入库单</div>`;
        html += `<div class="head">
      <div class="code" style="font-size: 20px;">公司名称：${sessionStorage.getItem('company')}</div>
      <div style="font-size: 20px;">订单编号：${sessionStorage.getItem('ORDER_CODE')}</div></div>`;
        html += `<div class="head">
      <div class="code" style="font-size: 20px;">订单ID：${sessionStorage.getItem('orderId')}</div>
      <div style="font-size: 20px;">送达日期：${sessionStorage.getItem('SEND_DAY')}</div>
      <div style="font-size: 20px;">第${index + 1}页/共${printDatas.length}页</div></div>`;
        html += `<div class="head">
      <div class="code" style="font-size: 20px;">供应商：${sessionStorage.getItem('SUPPLIER_NAME')}</div>
      <div class="code" style="font-size: 20px;"></div></div>`;
        html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
        html += '<tr><th style="width: 50px">序号</th> <th >产品</th> <th style="width: 40px">编码</th> <th >单位</th> <th style="width: 70px">总数</th> <th style="width: 70px">实收</th> <th width="80">库位</th> <th>生产日期</th><th>保质期</th> </tr>';
        html += '</div><div class="el-table__body">';

        printData.forEach((item, innerIndex) => {
          const dataIndex = index * this.printPageSize + innerIndex + 1;
          html += '<tr style="text-align: center">';
          html += `<td> ${dataIndex} </td> <td>${item.PRODUCT_NAME}</td> <td>${item.BUYED_PRODUCT_CODE}</td><td>${item.TYPE_UNIT}</td>
             <td>${item.REAL_COUNT}</td><td></td><td></td><td></td><td>${item.QGP} ${QGP_TIME_TYPE[item.QGP_TIME_TYPE]}</td>`;
          html += '</tr>';
        });

        html += '</div>';
        html += '</div>';
        html += '</table>';
        html += '</div>';
        html += '<div class="head"><div class="code" style="font-size: 20px;">收货员：</div><div class="code" style="font-size: 20px;">供应商：</div><div class="code" style="font-size: 20px;">日期：</div><div></div></div>';
        html += '</div>';
      });

      const windows = print(html);
      windows.close();
    },
    // 控制功能按钮
    async queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      await getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 搜索接口调用
    $_getSearchRushOrderList (NAME) {
      const data = {
        PRODUCT_NAME: this.seachForm.productName,
      };
      return new Promise((resolve, reject) => {
        chooseEntryFun(data).then((res) => {
          if (res.length === 0) {
            this.$message.show({ text: '暂无数据', type: 'success' });
          } else {
            resolve(res);
          }
        })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // ------------------搜索
    querySearch (queryString, callback) {
      this.$_getSearchRushOrderList(queryString).then((res) => {
        const results = res.map((item) => {
          item.value = item.PRODUCT_NAME;
          return item;
        });
        callback(results);
      });
    },
    //  点击搜索结果返回选中的结果
    handleSelect (item) {
      const temArr = [];
      temArr.push(item);
      this.dialogData = temArr;
    },
    // 点击编辑图库产品
    editOutProduct (row) {
      this.editFormVisible = true;
      this.inputItemData = row;
    },
    // 编辑入库产品模态款的确认
    editFormSubmit () {
      this.listData.filter((item) => {
        if (item.ORDER_DETAIL_ID === this.inputItemData.ORDER_DETAIL_ID) {
          item.IN_WAREHOUSE_PRODUCT_CODE = this.dialogData[0].PRODUCT_CODE;
          item.IN_WAREHOUSE_PRODUCT_NAME = this.dialogData[0].PRODUCT_NAME;
        }
      });
      this.editFormVisible = false;
    },
    // -----------------------------查询操作
    queryData () {
      const params = {
        ORDER_ID: this.orderID,
      };
      queryInStorageDetailFun(params).then((result) => {
        if (result.length) {
          this.listData = result[0].DETAIL.map((item, index) => Object.assign(item, {
            new_row: 0, showInput: 0, tabIndex: String(index + 1), BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
          }));
          this.rawData = result[0].DETAIL.map((item) => ({ ORDER_DETAIL_ID: item.ORDER_DETAIL_ID, REAL_COUNT: item.REAL_COUNT, REAL_FEE: item.REAL_FEE }));
          this.tableList = util.deepCopy(result[0].DETAIL);

          if (this.sotockEnterDetail.ORDER_ID) {
            for (const x of this.listData) {
              if (x.ORDER_DETAIL_ID in this.sotockEnterDetail) {
                for (const key in this.sotockEnterDetail[x.ORDER_DETAIL_ID]) if (key) this.$set(x, key, this.sotockEnterDetail[x.ORDER_DETAIL_ID][key]);
              }
            }

            this.$store.dispatch('SET_STOCK_ENTER_DETAIL', {});
          }
        } else {
          this.listData = [];
          this.rawData = [];
          this.tableList = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拆分
    splitProduct (row, index) {
      row.showInput = 1;
      const new_row = {
        ...row, new_row: 1, showInput: 1, REAL_COUNT: 0, REAL_FEE: 0, REAL_FEE_BEFORE_TAX: 0,
      };
      this.listData.splice(index + 1, 0, new_row);
    },
    // 删除拆分内容
    deleteSplit (row, index) {
      this.listData.splice(index, 1);
    },
    // 设置拆分行颜色
    setFontColor (new_row) {
      if (new_row === 1) {
        return {
          color: '#67C23A',
        };
      }
    },
    submit () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.listData.map((item) => ({
            ORDER_DETAIL_ID: item.ORDER_DETAIL_ID,
            PRODUCT_FEE: Number(item.REAL_FEE),
            PRODUCTION_DATE: item.SEND_DAY,
            PRODUCT_COUNT: item.REAL_COUNT,
            PRODUCING_AREA: item.PRODUCING_AREA,
            IW_PRODUCT_CODE: item.IN_WAREHOUSE_PRODUCT_CODE == '0' ? item.BUYED_PRODUCT_CODE : item.IN_WAREHOUSE_PRODUCT_CODE,
            SOURCE_COMPANY: item.SOURCE_COMPANY || '',
            CERT_CODE: item.CERT_CODE || '',
            CONTACT_PERSON: item.CONTACT_PERSON || '',
            CONTACT_PHONE: item.CONTACT_PHONE || '',
          }));
          const params = {
            ORDER_ID: this.orderID,
            PRODUCT_ARRAY: submitArr,
            WAREHOUSE_MODE: this.WAREHOUSE_MODE,
          };

          const stockInFileDict = JSON.parse(sessionStorage.getItem('stockInFileDict')) || {};
          if (stockInFileDict[this.orderID] && stockInFileDict[this.orderID].length) params.FILE_NAME = stockInFileDict[this.orderID][0].response.file_name;

          inStorageCofirmFun(params).then((result) => {
            if (params.FILE_NAME) {
              delete stockInFileDict[this.orderID];
              sessionStorage.setItem('stockInFileDict', JSON.stringify(stockInFileDict));
            }
            this.isLeftAfterSubmitting = true;
            this.$router.push({ name: 'stockEnter' });
            this.$message.show({ text: '入库成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },

    // 计算总价
    countTotalFee (row) {
      this.count = 0;
      this.relCountTotal = 0;
      const allData = this.listData;
      const dataSort = [];
      this.tableList.forEach((ele) => {
        if (ele.BUYED_PRODUCT_CODE == row.BUYED_PRODUCT_CODE) {
          this.realCount = ele.REAL_COUNT;
        }
      });
      allData.forEach((val, index) => {
        const array = dataSort[val.BUYED_PRODUCT_CODE] || [];
        array.push(val);
        dataSort[val.BUYED_PRODUCT_CODE] = array;
      });
      const newList = dataSort[row.BUYED_PRODUCT_CODE];
      newList.forEach((item) => {
        this.relCountTotal += Number(item.REAL_COUNT);
        if (item.new_row == 1) {
          this.count += Number(item.REAL_COUNT);
        }
      });
      if (row.new_row == 1) {
        this.$set(row, 'REAL_FEE', (Math.round((row.REAL_COUNT * row.REAL_PRICE) * 100) / 100).toFixed(2));
        row.REAL_FEE_BEFORE_TAX = ((row.REAL_COUNT * row.REAL_PRICE) / (1 + row.TAX_RATE / 100)).toFixed(2);
        this.newRealCount = Math.round((parseFloat(this.realCount) - parseFloat(this.count)) * 100) / 100;
        if (this.newRealCount < 0) {
          row.REAL_COUNT = 0;
          this.$set(row, 'REAL_FEE', 0);
          row.REAL_FEE_BEFORE_TAX = 0;
          this.$message.show({ text: '拆分总数和大于实收数量', type: 'warning' });
          return;
        }
        this.listData.forEach((element) => {
          if ((element.BUYED_PRODUCT_CODE == row.BUYED_PRODUCT_CODE) && element.new_row == 0) {
            element.REAL_COUNT = this.newRealCount.toFixed(2);

            this.$set(element, 'REAL_FEE', (Math.round((element.REAL_COUNT * element.REAL_PRICE) * 100) / 100).toFixed(2));
            element.REAL_FEE_BEFORE_TAX = ((element.REAL_COUNT * element.REAL_PRICE) / (1 + element.TAX_RATE / 100)).toFixed(2);
          }
        });
      } else if (row.new_row == 0) {
        if (this.realCount < this.relCountTotal) {
          row.REAL_COUNT = 0;
          this.$set(row, 'REAL_FEE', 0);
          row.REAL_FEE_BEFORE_TAX = 0;
          this.$message.show({ text: '拆分总数和大于实收数量', type: 'warning' });
          return;
        }
        this.$set(row, 'REAL_FEE', (Math.round((row.REAL_COUNT * row.REAL_PRICE) * 100) / 100).toFixed(2));
        row.REAL_FEE_BEFORE_TAX = ((row.REAL_COUNT * row.REAL_PRICE) / (1 + row.TAX_RATE / 100)).toFixed(2);
      }
    },
    // 计算总数
    getCount (row) {
      row.REAL_COUNT = row.REAL_FEE / row.REAL_PRICE;
      row.REAL_FEE_BEFORE_TAX = (row.REAL_FEE / (1 + row.TAX_RATE / 100)).toFixed(2);
    },
    勾选产品上传报告 (val) {
      this.勾选产品产品编码列表 = val;
    },
    // 上传批次报告
    showUploadBatch (row) {
      this.uploadBatchFormVisible = true;
      this.uploadBatchForm = { ...row };
    },
    closeUploadBatchForm () {
      this.批量上传报告模态框 = false;
      this.uploadBatchFormVisible = false;
      this.handleRemove();
    },
    handleSuccess (response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
      this.file_name = '';
    },
    确认批量上传报告 () {
      const promises = [];
      const errList = [];
      let 是否出现问题 = false;
      for (const item of this.勾选产品产品编码列表) {
        const params = {
          DETAIL_ID: item.ORDER_DETAIL_ID,
          PRODUCT_CODE: item.IN_WAREHOUSE_PRODUCT_CODE == '0' ? item.BUYED_PRODUCT_CODE : item.IN_WAREHOUSE_PRODUCT_CODE,
          FILE_URL: this.fileList.map((x) => x.response.file_name),
          SUBMIT_UNIT: this.批量上传报告表单.SUBMIT_UNIT,
          TEST_UNIT: this.批量上传报告表单.TEST_UNIT,
        };
        promises.push(uploadBatch(params).then(() => {

          // eslint-disable-next-line no-loop-func
        }).catch((error) => {
          是否出现问题 = true;
          errList.push(error);
        }));
      }
      Promise.all(promises).then(() => {
        if (是否出现问题) {
          this.$message.show({ text: errList, type: 'error' });
          return false;
        }
        this.批量上传报告表单 = {};
        this.$message.show({ text: '全部上传成功', type: 'success' });
        this.批量上传报告模态框 = false;
        this.fileList = [];
        this.queryData();
      });
    },
    $uploadBatch () {
      const params = {
        DETAIL_ID: this.uploadBatchForm.ORDER_DETAIL_ID,
        PRODUCT_CODE: this.uploadBatchForm.IN_WAREHOUSE_PRODUCT_CODE == '0' ? this.uploadBatchForm.BUYED_PRODUCT_CODE : this.uploadBatchForm.IN_WAREHOUSE_PRODUCT_CODE,
        FILE_URL: this.fileList.map((item) => item.response.file_name),
        SUBMIT_UNIT: this.uploadBatchForm.SUBMIT_UNIT,
        TEST_UNIT: this.uploadBatchForm.TEST_UNIT,
      };
      uploadBatch(params).then((result) => {
        this.$message.show({ text: '上传批次报告成功', type: 'success' });
        this.uploadBatchFormVisible = false;
        this.fileList = [];
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    downloadBatch (BATCH_REPORT_ID) {
      const params = {
        BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((result) => {
        this.查看批次报告模态框表单 = { ...result[0] };
        this.查看批次报告模态框 = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created () {
    this.queryBeforeFun();
    this.queryData();
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isLeftAfterSubmitting) {
      const dict = this.listData.reduce((obj, {
        ORDER_DETAIL_ID, PRODUCING_AREA, SEND_DAY, SOURCE_COMPANY, CERT_CODE, CONTACT_PERSON, CONTACT_PHONE,
      }) => {
        obj[ORDER_DETAIL_ID] = {
          PRODUCING_AREA, SEND_DAY, SOURCE_COMPANY, CERT_CODE, CONTACT_PERSON, CONTACT_PHONE,
        };
        return obj;
      }, {});
      this.$store.dispatch('SET_STOCK_ENTER_DETAIL', {
        ...dict,
        ORDER_ID: this.orderID,
      });
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    if (store.state.stock_enter_detail.ORDER_ID && Number(sessionStorage.getItem('orderId')) && Number(sessionStorage.getItem('orderId')) != store.state.stock_enter_detail.ORDER_ID) {
      MessageBox.confirm(`订单 ${store.state.stock_enter_detail.ORDER_ID}的入库单尚未提交，是否放弃填写并进入订单 ${sessionStorage.getItem('orderId')}的入库单详情？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        next(); // 进入页面
      }).catch(() => {
        next(false); // 取消进入
      });
    } else next();
  },
};
</script>
<style scoped>
.el-select {
  margin-right: 15px;
}

.el-input {
  margin-right: 15px;
  width: 200px;
}

.tableArea {
  margin-top: 20px;
}

i[class^="el-icon"] {
  margin-right: 5px;
  font-size: 16px;
  cursor: pointer;
}

.modify_table td {
  padding: 10px;
}

.item_title {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockEnterDetail.vue